import { connect } from 'react-redux';
import { hidePopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { NonVectorImageUploadPopup } from '../../../non-vector-image-upload-popup';
import { uploadLogoToAWS, uploadBoxLogo, showBoxBuilderPopupInCustomBoxStep } from '../../../../../redux/box-builder/box-builder.actions';
const mapDispatchToProps = dispatch => ({
  handleContinueUploadLogo: file => {
    dispatch(uploadLogoToAWS(file));
    dispatch(hidePopup());
    dispatch(showBoxBuilderPopupInCustomBoxStep());
  },
  handleUploadLogo: file => {
    setTimeout(() => {
      dispatch(uploadBoxLogo(file));
    }, 600);
  },
  onClose: () => dispatch(showBoxBuilderPopupInCustomBoxStep())
});
export default connect(null, mapDispatchToProps)(NonVectorImageUploadPopup);